import React from 'react';

interface Props {
  description?: string;
}

export const Description = ({ description }: Props) => {
  return (
    <section>
      <h2 className="f20 abbey fw2 lh-copy ma0 mb12 mb8-ns mb8-l mt24 mt40-m">Descrição</h2>
      <div className="flex flex-column flex-row-ns flex-column-m flex-column-l">{description}</div>
    </section>
  );
};
